import React from 'react'; 
import '../styles/NoPage.css';

export default function NoPage(){
return(
    <>
    <div className='no-page'>
    <h1>Error 404: Not found</h1>
    </div>  
    </>
)
}